/**
 * Konfigurator-Link Rewriter
 *
 * Der Konfigurator lebt unter /pages/konfigurator (mit Locale-Praefix je
 * Sprachversion). Dieses Script biegt zwei Sorten Alt-Links clientseitig auf
 * die korrekt lokalisierte Route um:
 *
 *   1. Links auf die tote Subdomain konfigurator.kiyo.eu (Altbestand aus
 *      Menue/Admin — Rest-Netz seit dem Cutover August 2026).
 *   2. Hart getippte relative Links ohne Locale-Praefix, z. B.
 *      /pages/konfigurator?setup=… in Template-Settings und Richtext
 *      (Stand 2026-08-20: 27 Stueck in 16 Templates). Ein Kunde auf
 *      /en/ oder /de-ch/ landete darueber sonst auf der deutschen
 *      EU-Version — falsche Sprache, falsche Waehrung. Serverseitig sind
 *      diese Links nicht umstellbar: Der Link-Picker (shopify://) kennt
 *      keine Query-Parameter, und Richtext-HTML lokalisiert Shopify nicht.
 *
 *   - de (Default)      → /pages/konfigurator
 *   - de-CH             → /de-ch/pages/konfigurator
 *   - en / fr / …       → /<locale>/pages/konfigurator
 *
 * Das Locale-Praefix kommt aus Shopify.routes.root (offizieller Weg) mit
 * Pfad-Fallback. Query-Parameter (?setup=…, ?region=…) bleiben erhalten;
 * bei Subdomain-Links wird auch eine Pfad-ID (konfigurator.kiyo.eu/aBc123)
 * als ?setup= uebernommen. Bereits korrekte Links werden nicht angefasst.
 */
(function () {
  'use strict';

  var PAGE_PATH = 'pages/konfigurator';
  var LINK_SELECTOR = 'a[href*="konfigurator.kiyo.eu"], a[href*="pages/konfigurator"]';

  function getLocaleRoot() {
    // Official: Shopify.routes.root is '/', '/en/', '/de-ch/', …
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof root === 'string' && root.charAt(0) === '/') {
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }
    // Fallback: derive from the current path (e.g. /de-ch/..., /en/...)
    var match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
    return match ? '/' + match[1].toLowerCase() + '/' : '/';
  }

  function rewriteLink(link) {
    try {
      var url = new URL(link.href);

      // Case 1: dead subdomain — rebuild the URL entirely.
      if (url.hostname === 'konfigurator.kiyo.eu') {
        var target = new URL(getLocaleRoot() + PAGE_PATH, window.location.origin);

        // Preserve a saved configuration: ?setup=… wins, otherwise a path id
        // like konfigurator.kiyo.eu/aBc123 (ignore the old locale prefixes).
        var setup = url.searchParams.get('setup');
        if (!setup) {
          var pathId = url.pathname.replace(/^\/(ch|en|fr)(\/|$)/i, '/').replace(/^\/|\/$/g, '');
          if (pathId && pathId.indexOf('.') === -1 && pathId.length > 3) setup = pathId;
        }
        if (setup) target.searchParams.set('setup', setup);

        link.href = target.toString();
        return;
      }

      // Case 2: internal link whose path misses (or carries a foreign)
      // locale prefix — normalize to the current page's locale, keep the
      // query string untouched. Already-correct links fall through as no-op,
      // which also keeps the MutationObserver from looping on our own write.
      if (url.origin !== window.location.origin) return;
      if (!/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/konfigurator\/?$/i.test(url.pathname)) return;
      var desired = getLocaleRoot() + PAGE_PATH;
      if (url.pathname === desired) return;
      url.pathname = desired;
      link.href = url.toString();
    } catch (e) {
      // Skip malformed URLs
    }
  }

  function rewriteAllLinks(root) {
    var links = (root || document).querySelectorAll(LINK_SELECTOR);
    for (var i = 0; i < links.length; i++) {
      rewriteLink(links[i]);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteAllLinks(); });
  } else {
    rewriteAllLinks();
  }

  // Watch for lazily rendered content (e.g. header drawer hydration) AND for
  // href attributes that get morphed back by the theme's section rendering.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].type === 'attributes') {
        rewriteLink(mutations[i].target);
        continue;
      }
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 1) {
          if (nodes[j].matches && nodes[j].matches(LINK_SELECTOR)) {
            rewriteLink(nodes[j]);
          }
          if (nodes[j].querySelectorAll) {
            rewriteAllLinks(nodes[j]);
          }
        }
      }
    }
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href']
  });

  // Also run after Shopify section rendering (e.g. section reloads in editor)
  document.addEventListener('shopify:section:load', function () { rewriteAllLinks(); });

  // Last line of defense: rewrite at click time (capture phase), so even a
  // link that slipped past every observer never navigates to the wrong
  // locale or the dead subdomain.
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest(LINK_SELECTOR);
    if (link) rewriteLink(link);
  }, true);
})();
